/**
 * "Try the quiet toolbar" — the per-person switch for The Quiet Toolbar
 * (10/10, https://claude.ai/artifact/867xubbA5qmtEe3s5KsP2c). Same pattern as
 * "Try the new Mailroom": a server-backed user preference, off by default, so
 * one person can try it without changing anyone else's screen.
 *
 * With it on:
 *   - the top bar has three chips that each count only what they own —
 *     Inbox (emails), Tasks (on you + came back, ONE number), Stuck (jobs);
 *   - no bell (office or field) — history is Recent activity in the avatar
 *     menu, with no badge;
 *   - no Tasks tab badge, no "N back" chip, no "Needs you", no Purchasing
 *     badge, no launcher Closeout badge;
 *   - marks sit on the thing itself (components/mark.tsx).
 */
import { useUserPreference } from "@/lib/user-preference";

export const QUIET_TOOLBAR_PREF = "quiet_toolbar";

/** Only mounted under a signed-in shell, so the preference read is always allowed. */
export function useQuietToolbar(): [boolean, (on: boolean) => void, { loaded: boolean }] {
    return useUserPreference<boolean>(QUIET_TOOLBAR_PREF, false);
}
